const KEYS = {
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32
};

angular.module('ui-ng-ax').factory('phxAxReturnFocusFactory', function () {
  const focusFactory = {};
  let currentFocusId = '';

  focusFactory.setFocusId = (focusId) => currentFocusId = focusId;

  focusFactory.getFocusId = () => currentFocusId;

  return focusFactory;

}).controller('phxAxReturnFocusController', function ($scope, phxFocusDelegate, phxAxReturnFocusFactory) {

  $scope.returnFocus = () => {
    phxFocusDelegate.focus(phxAxReturnFocusFactory.getFocusId());
  };

}).directive('phxAxReturnFocus', function phxAxReturnFocus() {
  return {
    restrict: 'A',
    scope: {
      eventKey: '@phxAxReturnFocus'
    },
    controller: 'phxAxReturnFocusController',
    link: function (scope, element, attrs) {

      element.on('click', (event) => {
        scope.returnFocus();
      });

      element.on('keyup', (event) => {
        if (event.which === KEYS.ESCAPE && scope.eventKey === 'escape') {
          scope.returnFocus();
        }
      });

      element.on('keypress', (event) => {
        event.cancelBubble = true;
        if (event.which === KEYS.ENTER) {
          scope.returnFocus();
        }
      });

    }
  }
}).controller('phxAxSetFocusToReturnController', function ($scope, phxAxReturnFocusFactory) {

  $scope.setReturnFocus = (focusId) => {
    phxAxReturnFocusFactory.setFocusId(focusId);
  };

}).directive('phxAxSetFocusToReturn', function phxAxSetFocusToReturn() {
  return {
    restrict: 'A',
    controller: 'phxAxSetFocusToReturnController',
    link: function (scope, element, attrs) {
      element.on('click', (event) => {
        if (!_.isUndefined(attrs.phxAxFocus)) {
          scope.setReturnFocus(attrs.phxAxFocus);
        }
      });
      element.on('keypress', (event) => {
        if (event.which === KEYS.ENTER && !_.isUndefined(attrs.phxAxFocus)) {
          scope.setReturnFocus(attrs.phxAxFocus);
        }
      });
    }
  }
});


// WEBPACK FOOTER //
// phx_ax_return_focus.es.js